import {useState} from 'react'
import IwinvCloud from './IwinvCloud'
import './external-cloud.css'

export const externalProviders=['IWINV','Hetzner','AWS','External']
export const providerLabel=value=>value==='External'?'기타 외부 클라우드':value
export default function ExternalCloud({provider,onProviderChange,children}){
 const [accountOpen,setAccountOpen]=useState(false)
 return <section className="external-cloud" aria-label="외부 클라우드">
   <header><div><h2>외부 클라우드</h2><p>IWINV·Hetzner 등 외부 업체에서 임대한 서버를 한곳에서 관리합니다.</p></div>
     <label>공급사<select aria-label="외부 클라우드 공급사" value={provider} onChange={e=>{onProviderChange(e.target.value);setAccountOpen(false)}}>
       <option value="all">전체 공급사</option>{externalProviders.map(p=><option value={p} key={p}>{providerLabel(p)}</option>)}</select></label></header>
   <div className="external-cloud-links"><a href="https://console.iwinv.kr/instance" target="_blank" rel="noreferrer">IWINV 콘솔 ↗</a><a href="https://console.hetzner.cloud/" target="_blank" rel="noreferrer">Hetzner 콘솔 ↗</a></div>
   {children}
   {(provider==='all'||provider==='IWINV')&&<details open={accountOpen} onToggle={e=>setAccountOpen(e.currentTarget.open)}>
     <summary>IWINV 계정 연결·서버 신청</summary>{accountOpen&&<IwinvCloud/>}
   </details>}
 </section>
}
